export const AssetItem = {
    ID: "",
    Archived: false,
}

export default AssetItem;